window.OKJS = window.OKJS || {};
(function (OKJS) {
    OKJS.VideoSetup = {

        settings: {
            videos: document.getElementsByTagName("video")
        },

        init: function () {
            var s = this.settings;
            if (s.videos.length > 0) {
                var throttledVideoUpdate = OKJS.Global.throttle(function () { OKJS.VideoSetup.updateStateVideo(s.videos) }, 500, { trailing: true });

                OKJS.VideoSetup.updateStateVideo(s.videos);

                window.addEventListener('scroll', function () { requestAnimationFrame(throttledVideoUpdate) }, Modernizr.passiveeventlisteners ? { passive: true } : false);
                window.addEventListener('resize', function () { requestAnimationFrame(throttledVideoUpdate) }, Modernizr.passiveeventlisteners ? { passive: true } : false);
            }
        },

        updateStateVideo: function (videos) {
            for (var i = 0; i < videos.length; i++) {
                var video = videos[i];
                OKJS.Global.isElementInViewport(video) ? video.play() : video.pause();
            };
        }
    };
}(window.OKJS));
